import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import DataSource from 'devextreme/data/data_source';
import { Crop, User } from 'shared';
import { CropService } from '../../stores/crop.service';

@Component({
  selector: 'app-crops-grid',
  templateUrl: './crops-grid.component.html',
  styleUrls: ['./crops-grid.component.scss']
})
export class CropsGridComponent implements OnInit {
  @Input()
  dataSource: DataSource;

  @Input()
  height: number | string;

  items: Crop[];

  @Output()
  itemsChange = new EventEmitter<Crop[]>();

  canEdit: boolean;
  canAdd: boolean;
  canDelete: boolean;
  ds: DataSource;

  constructor(
    private service: CropService,
    private user: User,
  ) {

    this.ds = this.service.newDataSource({
      paginate: false,
    });

    this.ds.store().on('loaded', (result) => {
      this.items = result.data;
      this.itemsChange.emit(this.items);
    });

    // Permissions
    this.canEdit = user.can('edit crops');
    this.canAdd = user.can('add crops');
    this.canDelete = user.can('delete crops');
  }

  ngOnInit(): void {
  }

  reloadDatasource(e: any) {
    if (this.dataSource) {
      this.dataSource.reload();
    }
  }
}
